import { AppState } from "../../../redux-configuration/AppState";
import { User } from "../../domain/entity/user";

export const loadLocalUserLoadingSelector = (appState: AppState): boolean => appState.registration.loadLocalUser.loading
export const loadLocalUserErrorSelector = (appState: AppState): string | undefined => appState.registration.loadLocalUser.error
export const localUserSelector = (appState: AppState): User | null => appState.registration.loadLocalUser.user
